import axios from 'axios'

// TODO: remove this and use new fetch_kofi_inventory_cache 
// export const fetch_shop_inventory = async (onComplete, onError) => {
//     try {
//         const response = await axios.get(process.env.REACT_APP_KOFI_CACHE_ENDPOINT + process.env.REACT_APP_INVENTORY_CACHE);
//         const inventory = response.data.items
//         onComplete(inventory)
//     } catch (err) {
//         onError(err)
//     }
// }

export const get_kofi_data_cache = async (onComplete, onError, cache_file_name) => { 
    const url = process.env.REACT_APP_KOFI_CACHE_ENDPOINT + cache_file_name
    // const headers = { 
        // 'HBNS-APP-ID': process.env.REACT_APP_HBNS_APP_ID,
        // 'Cache-Control': 'no-store', // Prevents the browser from storing the response in its cache
        // 'Pragma': 'no-cache', // For backward compatibility with HTTP/1.0 caches
        // 'Expires': '0' // For backward compatibility with older proxies/browsers 
    // }
    try {
        const response = await axios.get(url, { headers: { 
            // 'HBNS-APP-ID': process.env.REACT_APP_HBNS_APP_ID,
            'Cache-Control': 'no-cache, no-store, must-revalidate', // Prevents the browser from storing the response in its cache
            'Pragma': 'no-cache', // For backward compatibility with HTTP/1.0 caches
            'Expires': '0' // For backward compatibility with older proxies/browsers 
        } });
        const inventory = response.data.items
        onComplete(inventory)
    } catch (err) {
        onError(err)
    }
}

export const get_kofi_inventory_cache = async (onComplete, onError) => {
   await get_kofi_data_cache(onComplete, onError, process.env.REACT_APP_INVENTORY_CACHE)
}

export const get_kofi_commissions_cache = async (onComplete, onError) => {
   await get_kofi_data_cache(onComplete, onError, process.env.REACT_APP_COMMISSIONS_CACHE)
}

export const source_kofi_data = async (onComplete, onError, product_type) => {
    const url = `${process.env.REACT_APP_SOURCE_KOFI_DATA_ENDPOINT}${process.env.REACT_APP_KOFI_SHOP_ID}/${product_type}`
    const headers = { 
        'HBNS-APP-ID': process.env.REACT_APP_HBNS_APP_ID
     }
    try {
        const response = await axios.post(url, null, { headers } );
        const inventory = response.data.items
        onComplete(inventory)
    } catch (err) {
        onError(err)
    }
}

export const source_kofi_inventory = async (onComplete, onError) => {
    await source_kofi_data(onComplete, onError, 'inventory')
}

export const source_kofi_commissions = async (onComplete, onError) => {
    await source_kofi_data(onComplete, onError, 'commissions')
}

